<template>
  <div id="content">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <div class="inner">
      <h1 v-translate>Kodeky</h1>
    </div>
    <div class="inner_white">
        <div class="status search">
          <div class="field_left">
              <search-input input-class="search" v-model="formFields.search"></search-input>
          </div>
          <a
              v-if="$_createActionAllowed"
              :title="'Přidat kodek' | translate"
              :class="['add', 'add_expand', { open: newCodecOpen }, { btn_inactive: false }]"
              @click.prevent="toggleNewCodec()"
              v-translate>Přidat kodek
          </a>
        </div>
      <div :class="['filter', 'expand_content', { open: newCodecOpen }]">
        <div class="field_left">
          <p>
          <text-input
              id="codec-name-add-1"
              v-model="newCodec.name"
              :required="true"
              ref="newcodecnameref"
          >
            <translate class="translate">Název kodeku</translate>
          </text-input>
          </p>
          <p>
            <text-input
              id="codec-code-add-1"
              v-model="newCodec.code"
              :required="true"
              ref="newcodeccoderef"
            >
              <translate class="translate">Kód</translate>
            </text-input>
          </p>
        </div>
        <div class="field_right field_btn">
          <p class="field">
          <input
              type="submit"
              class="btn"
              :value="'Uložit' | translate"
              @click.prevent.stop="addNewCodec"
          />
        </p>
        </div>
      </div>

      <div class="table_overflow">
        <table class="vypis vypis_detail">
        <thead>
        <tr>
          <th class="no_padding drag_drop"></th>
          <th class="no_padding checkbox"/>
          <sorting-table-title
              v-for="title in codecsTableTitles"
              :key="title.key"
              :column="title.column"
              :sort="getActiveSort(title.column)"
              @changeSorting="changeSorting"
          >{{ title.name }}</sorting-table-title>
          <th class="no_padding edit"></th>
        </tr>
        </thead>

        <codec-row
            v-for="entity in entities"
            :entity="entity"
            :selectedEntities="selectedEntities"
            @input="select"
            :key="entity.id"
            @deleteCodec="deleteEntity"
            :ref="'codec-row-ref-'+entity.id"
        ></codec-row>
      </table>
      </div>
      <list-action-line
          :entities="entities"
          :offset="formFields.offset"
          :selected-entities="selectedEntities"
          :multiple-action-options="multipleActionOptions"
          @select-all="toggleSelectAll"
          @run-multiple-action="runMultipleAction"
          :limit="formFields.limit"
          :total-count="totalCount"
          @limit="setLimit"
          @offset="setOffset"
          ref="action_line"
      ></list-action-line>
    </div>
  </div>
</template>

<script>
import CodecRow from "@/components/views/codecs/CodecRow"
import listActions from "@/components/mixins/list-actions"

export default {
  name: "Codecs",
  components: {
    CodecRow,
  },
  mixins: [listActions],
  data() {
    return {
      moduleName: 'codecs',
      newCodecOpen: false,
      newCodec: {
        name: '',
        code: '',
      },
      formFields: {
        sort: {
          column: 'sName',
          direction: 'desc',
        }
      }
    }
  },
  created(CodecService) {
    this.entityService = CodecService
    this.createdInit()
  },
  computed: {
    codecsTableTitles() {
      return [
        {key: 1, name: this.$gettext('Název kodeku'), column: 'sName'},
        {key: 2, name: this.$gettext('Kód'), column: 'sCode'},
        {key: 3, name: this.$gettext('Vytvořeno'), column: 'sDateCreated'},
      ]
    },
    multipleActionOptions() {
      return [
        {value: 'choose', text: this.$gettext('Vyberte akci')},
        {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
      ]
    },
    csvHeaders(){
      return this.getCsvHeaderFromSortingTableTitle(this.codecsTableTitles)
    },
  },
  methods: {
    toggleNewCodec() {
      this.newCodecOpen = !this.newCodecOpen
      this.$emit('new-codec-open', this.newCodecOpen)
      if (this.newCodecOpen) {
        this.resetInput('newcodecnameref')
        this.resetInput('newcodeccoderef')
      }
    },
    addNewCodec() {
      this.entityService.createEntity(this.newCodec)
          .then(() => {
            this.getEntities()
            this.setSuccessMessage()
            this.$refs['newcodecnameref'].setForcedInvalid(false)
            this.$refs['newcodeccoderef'].setForcedInvalid(false)
            this.newCodecOpen = false;
          })
          .catch((error) => {
            this.$refs['newcodecnameref'].setForcedInvalid(false)
            this.$refs['newcodeccoderef'].setForcedInvalid(false)

            this.setErrorMessage(this._processListErrorMessage(error))
          })
    },
    resetInput(ref) {
      this.$refs[ref].setForcedInvalid(false)
      this.$refs[ref].setTouched(false)

      if (ref === "newcodecnameref") {
        this.newCodec.name = '';
      } else if (ref === "newcodeccoderef") {
        this.newCodec.code = '';
      }
    },
    _processListErrorMessage(error) {
      let errorMessage = null;

      this._.forEach(error['validation_errors'], function (message) {
        if (this._.includes(message, 'name must be set')) {
          errorMessage = this.$gettext('Název kodeku musí být uveden.');
          this.$refs['newcodecnameref'].setForcedInvalid(true, this.$gettext('Zadejte název'));
        } else if (this._.includes(message, 'code must be set')) {
          errorMessage = this.$gettext('Kód kodeku musí být uveden.');
          this.$refs['newcodeccoderef'].setForcedInvalid(true, this.$gettext('Zadejte kód'));
        } else if (message === "Code can contain only alphanumeric characters, dash and underscore!") {
          errorMessage = this.$gettext('Kód smí obsahovat pouze znaky [a-ZA-Z0-9-_].');
          this.$refs['newcodeccoderef'].setForcedInvalid(true, this.$gettext('Kód smí obsahovat pouze znaky [a-ZA-Z0-9-_].'));
        } else if (message.match("^Name \"(.+)\" is not unique\.$")) {
          errorMessage = this.$gettext('Název kodeku musí být unikátní.');
          this.$refs['newcodecnameref'].setForcedInvalid(true, this.$gettext('Název není unikátní'));
        } else if (message.match("^Code \"(.+)\" is not unique\.$")) {
          errorMessage = this.$gettext('Kód kodeku musí být unikátní.');
          this.$refs['newcodeccoderef'].setForcedInvalid(true, this.$gettext('Kód není unikátní'));
        } else if (message.match("^Unable to delete codec - there are (.+) device types with given codec\.$")) {
          errorMessage = this.$gettext("Kodek nelze smazat - existují typy zařízení s tímto kodekem.");
        } else if (message.match("^Unable to delete codec - there are (.+) stream profiles with given codec\.$")) {
          errorMessage = this.$gettext("Kodek nelze smazat - existují profily streamů s tímto kodekem.");
        } else {
          errorMessage = message;
        }
      }.bind(this))

      return errorMessage || error['error_message'];
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/codecs/CodecsList.vue